import { render, staticRenderFns } from "./DashboardFounderConsultList.vue?vue&type=template&id=21937681&"
import script from "./DashboardFounderConsultList.vue?vue&type=script&lang=ts&"
export * from "./DashboardFounderConsultList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports